export default "__VITE_ASSET__CxWbHH3S__"